/**
 * repostTip.jsx
 *
 * @Author: jruif
 * @Date: 2018/2/25 下午1:47
 */

import React from 'react';
// import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { Modal, Tooltip, Button } from 'neatui';
import ajax from '../../util/ajax';

class RepostTip extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
    };
  }

  handleRepost = () => {
    const { wemediaId, dataset } = this.props;
    ajax(
      `/${dataset.type + '/' + dataset.id}/addRepost.do`,
      {
        method: 'post',
        data: {
          mediaId: wemediaId,
        },
      },
      rs => {
        Modal.success({
          title: '转载成功',
          content: '',
        });
      },
    );
  };

  onSure = e => {
    this.handleRepost();
    this.onCancel();
  };

  onCancel = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { children, onSure, wemediaId, data, ...other } = this.props;
    return (
      <Tooltip {...other} isOpen={this.state.isOpen} onOpen={() => this.setState({ isOpen: true })}>
        {children}
        <p>
          <Button size="small" className="tool-tip-btn" type="primary" onClick={this.onSure}>
            确定
          </Button>
          <Button size="small" className="tool-tip-btn" onClick={this.onCancel}>
            取消
          </Button>
        </p>
      </Tooltip>
    );
  }
}

export default RepostTip;
